import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ElevatorPageRoutingModule } from './elevator-routing.module';

import { ElevatorPage } from './elevator.page';

import { AgmCoreModule } from '@agm/core';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ElevatorPageRoutingModule,
    TranslateModule,
    AgmCoreModule.forRoot({
      apiKey: "AIzaSyDrQ8y_m1TXhldJszx3BFOOrXYkF5pRvpg"
    })
  ],
  
  declarations: [ElevatorPage]
})
export class ElevatorPageModule {}
